import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=168762da&scoped=true&"
import script from "./tinymce-editor.vue?vue&type=script&lang=ts&"
export * from "./tinymce-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168762da",
  null
  
)

export default component.exports